import React from "react";
import MiniDrawer from "./Drawer/Menu/Menu";
import AppRoutes from "./Drawer/Routes";
import { Box } from "@mui/material";
import MainLayout from "./Pages/Main";
import { BASENAME } from "./config";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginProvider from "./Pages/Login/LoginProvider";
import ForgotPasswordPage from "./Pages/Login/ForgotPasswordPage";
import ResetPasswordPage from "./Pages/Login/ResetPasswordPage";
import withAppProviders from "./withAppProviders";

const App: React.FC = () => {
  return (
    <Box data-testid="pos-ui-app">
      <MainLayout>
        <BrowserRouter basename={BASENAME}>
          <Routes>
            {/* Public auth-recovery routes — MUST sit above the
                LoginProvider gate. Users hitting these from an SMS/email
                link have no session yet, so they cannot pass through the
                Sanctum-protected branch below. */}
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password"  element={<ResetPasswordPage />} />

            {/* Main admin app — everything else */}
            <Route
              path="/*"
              element={
                <LoginProvider>
                  <Box>
                    <MiniDrawer>
                      <AppRoutes />
                    </MiniDrawer>
                  </Box>
                </LoginProvider>
              }
            />
          </Routes>
        </BrowserRouter>
      </MainLayout>
    </Box>
  );
};

export default withAppProviders(App);
